import { render, staticRenderFns } from "./SentOrder.vue?vue&type=template&id=0e68c113&scoped=true&"
import script from "./SentOrder.vue?vue&type=script&lang=js&"
export * from "./SentOrder.vue?vue&type=script&lang=js&"
import style0 from "./SentOrder.vue?vue&type=style&index=0&id=0e68c113&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e68c113",
  null
  
)

export default component.exports